import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import UserContext from '../tools/contextLib'
import { browserName, browserVersion } from 'react-device-detect';
import axios from 'axios';
import { UnderConstruction } from './UnderConstruction';
import UnderConstructionPDF from '../Documents/UnderConstruction.pdf';
import moment from 'moment';
import LoadingSpin from "react-loading-spin";
import { Table, Form, FormGroup, Input, Label, Button } from 'reactstrap';
import { connect } from 'react-redux';

class ClusterManage extends Component {
    static displayName = ClusterManage.name;

    constructor(props) {
        super(props);
        this.state = {
            returnable: this.props.reduxData.userInfo,
            browser: `${browserName}${browserVersion}`,
            ip: "",
            permissionFlag: true,
            tableData: [],
            xvalOptions: [],
            xvalActive: "DEFAULT",
            degActive: "",
            descActive: ""
        }
        this.getUserInfo();
        this.testPermission();
        this.getTableData();
        this.getOptionList();
    }

    async getData() {
        const response = await fetch('https://api.ipify.org?format=json', { dataType: 'jsonp' });
        const data = await response.json();
        this.setState({
            ip: data.ip
        })
        this.getUserInfo();
    }

    async getUserInfo() {//NOTE: This is being done because the page is being built before the Redux store has been fully implemented. Will need to come back here once it's done.
                            //UPDATE 20240912: in process of implementing Redux functionality. This function will have to remain solely for the expOption feature. However, we don't need the fetch.
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        //const response = await fetch('user', { method: 'GET', headers: { 'Authorization': bearerVAR } });
        //const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        let today = new Date().toISOString().slice(0, 10)
        this.setState({
            //returnable: data,
            expOption: today
        });
        
    }

    async testPermission() {
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk,
            pagepk: "/ClusterManage"
        }
        const response = await fetch('ValidDepartments', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        this.props.updateFetchTime();
        this.setState({
            permissionFlag: data
        })
    }

    async getTableData() {
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        //localStorage.setItem("lastFetch", moment());
        this.props.updateFetchTime();
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk
        }
        const response = await fetch('GetClusterData', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        this.setState({
            tableData: data
        })
    }

    async getOptionList() {
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        //localStorage.setItem("lastFetch", moment());
        this.props.updateFetchTime();
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk
        }
        const response = await fetch('GetXvalOptions', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        this.setState({
            xvalOptions: data
        })
        
    }

    componentDidMount() {

    }

    async addNew(e) {
        e.preventDefault();
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        //localStorage.setItem("lastFetch", moment());
        this.props.updateFetchTime();
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk,
            xval: this.state.xvalActive,
            deg: this.state.degActive,
            desc: this.state.descActive
        }
        const response = await fetch('AddClusterDesc', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        this.setState({
            xvalActive: "DEFAULT",
            degActive: "",
            descActive: ""
        })
        this.getTableData();
        this.getOptionList();
    }

    async removeRecord(xval,desc) {
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        //localStorage.setItem("lastFetch", moment());
        this.props.updateFetchTime();
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk,
            xval: xval,
            desc: desc
        }
        const response = await fetch('RemoveCluster', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        this.getTableData();
        this.getOptionList();
    }

    render() {
        if (this.state.permissionFlag == false) {
            this.props.passNewPage(-1);
        }
        //if (this.props.justSwitch == true) {
        //    this.props.passNewPage(1);
        //}
        return (<div>
            <Form className='d-flex' onSubmit={(e) => this.addNew(e) }>
                <FormGroup>
                    <Label>Code XVAL</Label>
                    <Input type="select" id="xval" name="xval" value={this.state.xvalActive} onChange={(e) => this.setState({xvalActive: e.target.value}) }>
                        <option value="DEFAULT" disabled>Select</option>
                        {this.state.xvalOptions.map(item => (
                            <option value={item}>{item}</option>
                        )) }
                    </Input>
                </FormGroup>
                <FormGroup>
                    <Label>Degree - leave blank for all</Label>
                    <Input type="text" name="degree" id="degree" value={this.state.degActive} onChange={(e) => this.setState({ degActive: e.target.value })} />
                </FormGroup>
                <FormGroup>
                    <Label>Cluster Name</Label>
                    <Input type="text" name="desc" id="desc" value={this.state.descActive} onChange={(e) => this.setState({descActive: e.target.value}) } />
                </FormGroup>
                {this.state.xvalActive != "DEFAULT" && this.state.descActive != "" &&
                <Button outline color="success" type="submit">Submit</Button>}
            </Form><br />
            <Table>
                <thead>
                    <tr>
                        <th>Code_XVAL</th>
                        <th>Degree</th>
                        <th>Description</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {this.state.tableData.map(item => (
                        <tr>
                            <td>{item.code_xval}</td>
                            <td>{item.degree}</td>
                            <td>{item.desc}</td>
                            <td><Button color="danger" outline onClick={() => this.removeRecord(item.code_xval,  item.desc)}>Delete</Button></td>
                        </tr>
                    )) }
                </tbody>
            </Table>
            <br />
        </div>);
    }
}

const mapStateTo = state => ({
    reduxData: state
})

const mapDispatchTo = (dispatch) => {
    return {
        updateFetchTime: () => dispatch({ type: 'foundation/setFetchTime' })
    }
}

export default connect(mapStateTo, mapDispatchTo)(ClusterManage);